import { useState, useEffect } from 'react';

import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import { GatsbyImage } from 'gatsby-plugin-image';

import useBrowserMode from '@/shared/hooks/useBrowserMode';

import Button from '../../atoms/button/button';

import './payment-method.scss';
import { getAssetUrl } from '@/utils/contentFullAsset';

const PaymentMethod = (props) => {
  const {
    contentInfo,
    setStepPage,
    watchName,
    watchLastname,
    watchDocType,
    watchDocument,
    watchEmail,
    watchTelephone,
    setCancelConfirmation,
    loader,
    fluxType,
    gigyaContext,
    haveIntermediateStep,
  } = props;
  const [check, setCheck] = useState(false);
  //   const [isDark] = useChangeTheme()
  const [isDark, setIsDark] = useState<boolean>(false);
  const { isBrowser } = useBrowserMode();
  const dataTheme = localStorage.getItem('class_theme') || null;
  const options = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_node: any, children: any) => <p>{children}</p>,
      [INLINES.HYPERLINK]: (node, next) => (
        <a href={node.data.uri} rel="noopener noreferrer" target="_blank" title={node.data.uri}>
          {next}
        </a>
      ),
    },
  };

  useEffect(() => {
    if (isBrowser) {
      if (dataTheme !== null) {
        setIsDark(false);
      } else {
        setIsDark(true);
      }
    }
  }, [dataTheme]);

  return (
    <div className="m-payment">
      <div className="m-payment__head">
        <div className="m-payment__head__info">
          <div className="m-payment__head__info__title">
            <p className="m-payment__head__info__title__pay">{contentInfo[0].nombre}</p>
            <p className="m-payment__head__info__title__desc">{contentInfo[0].subtitulo}</p>
          </div>
          <div className="m-payment__head__info__content">
            <div className="m-payment__head__info__content__item">
              <div className="m-payment__head__info__content__item__description">
                <div className="m-payment__head__info__content__item__description__number">
                  <p>1</p>
                </div>
                <div className="m-payment__head__info__content__item__description__content">
                  <p className="m-payment__head__info__content__item__description__content__name">
                    {contentInfo[1].nombre}
                  </p>
                  <p className="m-payment__head__info__content__item__description__content__desc">
                    {contentInfo[1].subtitulo}
                  </p>
                </div>
              </div>
              <div className="m-payment__head__info__content__item__img img-one">
                {contentInfo[1].imagen[!isDark ? 0 : 1].file &&
                  contentInfo[1].imagen[!isDark ? 0 : 1].file.url && (
                    <div className={`img-one__container ${isDark ? '-dark' : '-light'}`}>
                      <img
                        src={
                          isDark
                            ? 'https://static.placetopay.com/placetopay-logo.svg'
                            : 'https://static.placetopay.com/placetopay-logo-dark-background.svg'
                        }
                        alt={contentInfo[1].imagen[!isDark ? 0 : 1].title}
                        title={contentInfo[1].imagen[!isDark ? 0 : 1].title}
                      />
                    </div>
                  )}
              </div>
            </div>
            <div className="m-payment__head__info__content__item">
              <div className="m-payment__head__info__content__item__description">
                <div className="m-payment__head__info__content__item__description__number">
                  <p>2</p>
                </div>
                <div className="m-payment__head__info__content__item__description__content">
                  <p className="m-payment__head__info__content__item__description__content__name">
                    {contentInfo[2].nombre}
                  </p>
                  <p className="m-payment__head__info__content__item__description__content__desc">
                    {contentInfo[2].subtitulo}
                  </p>
                </div>
              </div>
              <div className="m-payment__head__info__content__item__img">
                {contentInfo[2].imagen &&
                contentInfo[2].imagen[!isDark ? 0 : 1] &&
                contentInfo[2].imagen[!isDark ? 0 : 1].gatsbyImage ? (
                  <GatsbyImage
                    loading="eager"
                    image={contentInfo[2].imagen[!isDark ? 0 : 1].gatsbyImage}
                    alt={contentInfo[2].imagen[!isDark ? 0 : 1].title}
                    title={contentInfo[2].imagen[!isDark ? 0 : 1].title}
                  />
                ) : (
                  contentInfo[2].imagen[!isDark ? 0 : 1].file &&
                  contentInfo[2].imagen[!isDark ? 0 : 1].file.url && (
                    <img
                      src={getAssetUrl(contentInfo[2].imagen[!isDark ? 0 : 1])}
                      alt={contentInfo[2].imagen[!isDark ? 0 : 1].title}
                      title={contentInfo[2].imagen[!isDark ? 0 : 1].title}
                    />
                  )
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="m-payment__body">
        <div className="m-payment__body__term">
          <div
            className={`m-payment__body__term__check${check ? '--active' : ''}`}
            onClick={() => setCheck(!check)}
          >
            {check && <i className="icon-check1" />}
          </div>
          <div className="m-payment__body__term__desc">
            {contentInfo &&
              documentToReactComponents(JSON.parse(contentInfo[3].tituloEnriquecido.raw), options)}
          </div>
        </div>
        <div className="m-payment__body__btn">
          <Button
            type="button"
            classname="primary"
            text={contentInfo[4].copyBoton}
            isDisabled={false}
            onClickAction={() => {
              haveIntermediateStep === true || haveIntermediateStep === undefined
                ? setStepPage(0.1)
                : setStepPage(0);
            }}
            loader={loader}
          />
          <Button
            type="button"
            classname="secondary"
            text={contentInfo[5].copyBoton}
            isDisabled={
              !(
                check &&
                (!gigyaContext?.gigyaAccount
                  ? watchName && watchLastname && watchDocument && watchDocType
                  : true) &&
                watchTelephone &&
                watchEmail
              )
            }
            loader={loader}
            onClickAction={() => {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: 'pushEventGA',
                category: 'HomePersonas',
                action: `Clic${
                  fluxType === 'educacion' ? 'PagoPensionesYSemestre' : 'ClicPagoCreditoPersonas'
                }`,
                label: 'ContinuarPaso2',
              });
            }}
          />
        </div>
        {!loader && (
          <p className="m-payment__body__cancel" onClick={() => setCancelConfirmation(true)}>
            {contentInfo[6].copyBoton}
          </p>
        )}
      </div>
    </div>
  );
};

export default PaymentMethod;
